import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const getBonusList = createAsyncThunk(
  "getBonusList/getBonusList",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("bonus");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const getBonusListSlice = createSlice({
  name: "getBonusList",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBonusList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBonusList.fulfilled, (state, action) => {
          
          
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getBonusList.rejected, (state, action) => {
        
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default getBonusListSlice.reducer;
